import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'

// 获取订单信息
export const getOrderList = async (params: object) => {
  return await GET({
    url: Api.getOrderList,
    params: {
      ...params
    },
    headers: {
      rpcType: 'dubbo',
      'Client-Id': 'iss_courier',
      'Content-Type': 'application/json'
    },
    showError: false
  })
}

export const applyRefund = async (params: object) => {
  return await POST({
    url: Api.applyRefund,
    data: params,
    headers: {
      rpcType: 'dubbo',
      'Client-Id': 'iss_courier',
      'Content-Type': 'application/json'
    },
    showError: false
  })
}
export const confirmSign = async (params: object) => {
  return await POST({
    url: Api.confirmSign,
    data: params,
    headers: {
      rpcType: 'dubbo',
      'Client-Id': 'iss_courier',
      'Content-Type': 'application/json'
    },
    showError: false
  })
}
